import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Typography, HtmlEmailViewer} from 'views/components';
import {Translate, translate} from 'views/module';

const EMPTY_EMAIL = {
  from: '',
  to: '',
  subject: '',
  html: '',
  text: '',
};

const EmailMessage = (props) => {
  const {
    parsedEmail: parsedEmailProp,
  } = props;
  const parsedEmail = parsedEmailProp || EMPTY_EMAIL;

  const emailMetadata = [
    {
      label: translate('client.ClientDetail.Correspondance.Correspondance.EmailMetadata.From'),
      value: parsedEmail.from,
    },
    {
      label: translate('client.ClientDetail.Correspondance.Correspondance.EmailMetadata.Subject'),
      value: parsedEmail.subject,
    },
    {
      label: translate('client.ClientDetail.Correspondance.Correspondance.EmailMetadata.To'),
      value: parsedEmail.to,
    },
  ].filter((item) => Boolean(item.value));

  return (
    <Stack
      sx={{
        py: 0,
      }}
      spacing={1}
    >
      <Stack spacing={0.5}>
        {
          emailMetadata.map((item) => (
            <Typography
              key={item.label}
              variant='body2'
              sx={{
                color: 'text.secondary',
                wordBreak: 'break-word',
                fontSize: '12px',
                lineHeight: '19px',
              }}
            >
              <Box component='span' sx={{fontWeight: 500}}>
                {`${item.label}: `}
              </Box>
              {item.value}
            </Typography>
          ))
        }
      </Stack>
      <HtmlEmailViewer
        html={parsedEmail.html}
        text={parsedEmail.text}
        showMoreLabel={<Translate expression='generic.ShowMore' />}
        showLessLabel={<Translate expression='generic.ShowLess' />}
      />
    </Stack>
  );
};
EmailMessage.propTypes = {
  parsedEmail: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
    subject: PropTypes.string,
    html: PropTypes.string,
    text: PropTypes.string,
  }),
};

export default React.memo(EmailMessage);
